// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"347":"f624b14f","488":"bf5c20e0","508":"a94819a7","731":"00f061c6"}[chunkId] + ".chunk.js";
};